var render = function (_h,_vm) {var _c=_vm._c;return _c('font-awesome-icon',{staticClass:"icon-disc",class:{
    'icon-disc-active': _vm.props.active
  },attrs:{"icon":"compact-disc"}})}
var staticRenderFns = []

export { render, staticRenderFns }